module.exports = require('./dist/lib/accessible-autocomplete.react.min')
